/*
 *
 * CONVERSATIONS constants
 *
 */

export const GET_CONVERSATIONS_REQUEST_SENT = 'src/conversations/GET_CONVERSATIONS_REQUEST_SENT';
export const GET_CONVERSATIONS_REQUEST_SUCCEED = 'src/conversations/GET_CONVERSATIONS_REQUEST_SUCCEED';
export const GET_CONVERSATIONS_REQUEST_FAILED = 'src/conversations/GET_CONVERSATIONS_REQUEST_FAILED';

export const SHOW_CONVERSATION_DETAILS = 'src/conversations/SHOW_CONVERSATION_DETAILS';
export const SHOW_CONVERSATIONS_LIST = 'src/conversations/SHOW_CONVERSATIONS_LIST';

export const START_CONVERSATION_REQUEST_SENT = 'src/conversations/START_CONVERSATION_REQUEST_SENT';
export const START_CONVERSATION_REQUEST_SUCCEED = 'src/conversations/START_CONVERSATION_REQUEST_SUCCEED';
export const START_CONVERSATION_REQUEST_FAILED = 'src/conversations/START_CONVERSATION_REQUEST_FAILED';

export const RESOLVE_CONVERSATION_REQUEST_SENT = 'src/conversations/RESOLVE_CONVERSATION_REQUEST_SENT';
export const RESOLVE_CONVERSATION_REQUEST_SUCCEED = 'src/conversations/RESOLVE_CONVERSATION_REQUEST_SUCCEED';
export const RESOLVE_CONVERSATION_REQUEST_FAILED = 'src/conversations/RESOLVE_CONVERSATION_REQUEST_FAILED';

export const RESET_DATA_REQUEST = 'src/conversations/RESET_DATA_REQUEST';

